import { URL_REFRESH, V1, AUTH, BASE, API } from '../constants';
import {
  getTokenCookies,
  addTokenCookies,
  removeTokenCookies,
} from './authCookiesWeb';
import { isTokenExpired } from './tokenTimeCheck';
import { useAuth } from '@jobcost-monorepo/ui';

interface ReturnFunction {
  token: string;
  refresh: string;
}

export const fetchRefreshToken = async (
  refreshToken: string,
): Promise<ReturnFunction | null> => {
  const headers = new Headers();

  headers.set('content-type', 'application/json;charset=UTF-8');

  const options = {
    method: 'POST',
    headers,
    body: JSON.stringify({ token: refreshToken }),
  };

  try {
    const response = await fetch(
      `${BASE}${API}${V1}${AUTH}${URL_REFRESH}`,
      options,
    );
    if (response.ok) {
      const responseJson = await response.json();
      const { access_token, refresh_token } = responseJson;
      return { token: access_token, refresh: refresh_token };
    }
    return null;
    // @ts-ignore
  } catch (error: never) {
    console.log(error);
    return null;
  }
};

export const checkTokenValidity = async (): Promise<
  string | null | undefined
> => {
  const { accessToken, refreshToken } = getTokenCookies();
  const isExpired = await isTokenExpired(accessToken);
  if (!isExpired) {
    return accessToken;
  }
  if (accessToken && refreshToken) {
    try {
      const result = await fetchRefreshToken(refreshToken);
      const { token, refresh } = result ?? {};
      if (token && refresh) {
        addTokenCookies({
          accessToken: token,
          refreshToken: refresh,
        });
        return token;
      }
      removeTokenCookies();
      return null;
      // @ts-ignore
    } catch (error: never) {
      console.log(error);
      removeTokenCookies();
      return null;
    }
  }

  removeTokenCookies();
  return null;
};

export function checkIfAdmin(): boolean {
  const { user } = useAuth();
  return user?.role === 'ADMIN';
}
